/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const CACertificateSignatureAlgorithm = {
    Sha256WithRsaEncryption: 'SHA256_WITH_RSA_ENCRYPTION',
    Sha384WithRsaEncryption: 'SHA384_WITH_RSA_ENCRYPTION',
    Sha512WithRsaEncryption: 'SHA512_WITH_RSA_ENCRYPTION'
} as const;

export type CACertificateSignatureAlgorithm = typeof CACertificateSignatureAlgorithm[keyof typeof CACertificateSignatureAlgorithm];



